import React, { useEffect, useState } from 'react';
import {Link } from 'react-router-dom'
import {
  Collapse,
  ListItemIcon ,
  ListItemText,
  MenuItem,
  MenuList,
  Tooltip,
} from '@material-ui/core';
import {
    //Dashboard,
    ListAlt,
    RemoveCircle,
    AccountBox,
    CardTravel,
    //DriveEta,
    Home,
    //Loyalty,
    //CreditCard,
    ExpandLess,
    ExpandMore,
    Business,
    LocalTaxi,
    People,
    LiveHelp,
    AvTimer,
    LinearScale,
    MenuBook,
    LibraryBooks,
    Explore,
    Payment,
    PinDrop,
    AssignmentReturned,
    Work,
    Forum,
    ConfirmationNumber,
    AddAlert,
    NotificationsActive,
    ContactPhone,
    AmpStories,
    PieChart,
    Dashboard,
    ArtTrack, SupervisorAccount, ShowChart,
    Loyalty, Map, SettingsApplications, SettingsApplicationsOutlined, Sms
} from '@material-ui/icons';

export const HomeListItems = ({pathName ,listItemColor }) => {

  return (
    <MenuList>
      <Tooltip title="Accueil" placement="right" >
        <MenuItem component={Link} to='/' selected={pathName === "/"}>
          <ListItemIcon  >
                <Home color="primary"/>
            </ListItemIcon>
          <ListItemText primary="Accueil"  className={listItemColor}  />
        </MenuItem>
      </Tooltip>
    </MenuList>
)} ;


export const MainListItems = ({pathName ,listItemColor , roles }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
     if(pathName === "/map/status" || pathName === "/general/payement" || pathName === "/general/timeSlot" || pathName === "/general/lines" || pathName === "/general/linesRequests" || pathName==="/general/dropPoints"  ){
      setOpen(true)
     }else{
      setOpen(false)
     }
  }, [pathName])

  const handleClick = () => {
    setOpen(!open);
  };


  return (

  <MenuList style={ roles.timeslots || roles.points || roles.payments || roles.lines || roles["code promo"] ? {} : {display : 'none'}}>
    <Tooltip title="General" placement="right">

      <MenuItem onClick={handleClick}>
          <ListItemIcon>
            <Business color="primary" />
          </ListItemIcon>
          <ListItemText primary="General" className={listItemColor} />
          {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
      </MenuItem>

    </Tooltip>
    {/* Collapsing items */}
      <Collapse in={open} timeout="auto" unmountOnExit>
          <MenuList component="div" disablePadding>
              <Tooltip title="Drop Points" placement="right" style={ !roles.points ? { display : 'none'} : {}} >

                  <MenuItem component={Link} to='/general/dropPoints' selected={pathName === "/general/dropPoints"}>
                      <ListItemIcon>
                          <PinDrop   />
                      </ListItemIcon>
                      <ListItemText primary="Drop Points"  />
                  </MenuItem>
              </Tooltip>

              <Tooltip title="Historique des Commisions" placement="right" style={ !roles.payments ? { display : 'none'} : {}} >

                  <MenuItem component={Link} to='/general/payement' selected={pathName === "/general/payement"}>
                      <ListItemIcon>
                          <Payment   />
                      </ListItemIcon>
                      <ListItemText primary="Historique des commisions"  />
                  </MenuItem>
              </Tooltip>

              <Tooltip title="créneau horaire" placement="right" style={ !roles.timeslots ? { display : 'none'} : {}}>

                  <MenuItem component={Link} to='/general/timeSlot' selected={pathName === "/general/timeSlot"}>
                      <ListItemIcon>
                          <AvTimer  />
                      </ListItemIcon>
                      <ListItemText primary="créneau horaire"   />
                  </MenuItem>
              </Tooltip>

              <Tooltip title="Lignes" placement="right" style={ !roles.lines ? { display : 'none'} : {}}  >

                  <MenuItem component={Link} to='/general/lines' selected={pathName === "/general/lines"}>
                      <ListItemIcon>






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































                          <LinearScale  />
                      </ListItemIcon>
                      <ListItemText primary="Lignes"   />
                  </MenuItem>
              </Tooltip>
              <Tooltip title="Lignes Requests" placement="right" style={ !roles.lines ? { display : 'none'} : {}}  >

                  <MenuItem component={Link} to='/general/linesRequests' selected={pathName === "/general/linesRequests"}>
                      <ListItemIcon>
                          <LinearScale  />
                      </ListItemIcon>
                      <ListItemText primary="Lignes Requests"   />
                  </MenuItem>
              </Tooltip>

          </MenuList>

      </Collapse>
    </MenuList>
)};



export const BookingListItems = ({pathName , listItemColor , roles }) => {
  
  const [open, setopen] = useState(false);

  useEffect(() => {
      if(pathName === "/booking" || pathName === "/booking/bookingRequest" || pathName === "/bookingRequest" || pathName==="/booking/cancellations"){
        setopen(true)
      }else{
        setopen(false)
      }
  }, [pathName])

  const handleClick = () => {
    setopen(!open);
  };

  return (
      <MenuList style={ roles.bookings || roles.bookingCancellationReasons || roles.bookingRequests  ? {} : {display : 'none'}}>
          <Tooltip  title="Réservations" placement="right">
            <MenuItem onClick={handleClick}>
              <ListItemIcon>
              <MenuBook color="primary" />
            </ListItemIcon>
            <ListItemText primary="Réservations" className={listItemColor} />
            {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
            </MenuItem>
          </Tooltip>
          {/* Collapsing items */}
            <Collapse in={open} timeout="auto" unmountOnExit>
                <MenuList component="div" disablePadding>
                    <Tooltip style={ roles.bookings? {} : {display : 'none'}} title="Historique des  Réservations" placement="right" >
                        <MenuItem component={Link} to='/booking' selected={pathName === "/booking"}>
                            <ListItemIcon>
                                <LibraryBooks  />
                            </ListItemIcon>
                            <ListItemText primary="Historique des Réservations" />
                        </MenuItem>
                    </Tooltip>
                    <Tooltip style={ roles.bookingCancellationReasons ? { } : {display :'none'}} title="Annulations" placement="right" >
                        <MenuItem component={Link} to='/booking/cancellations' selected={pathName === "/booking/cancellations"}>
                            <ListItemIcon>
                                <RemoveCircle  />
                            </ListItemIcon>
                            <ListItemText primary="Booking Requests" />
                        </MenuItem>
                    </Tooltip>
                    <Tooltip style={ roles.bookingRequests ? { } : {display : 'none'}} title="Booking Requests" placement="right" >
                        <MenuItem component={Link} to='/booking/bookingRequest' selected={pathName === "/booking/bookingRequest"}>
                            <ListItemIcon>
                                <AssignmentReturned />
                            </ListItemIcon>
                            <ListItemText primary="Booking Requests" />
                        </MenuItem>
                    </Tooltip>
                </MenuList>
            </Collapse>
        </MenuList>
  )} ;



  export const TripListItems = ({pathName , listItemColor , roles}) => {
    const [open, setopen] = useState(false);

    useEffect(() => {
        if(pathName === "/trips" || pathName === "/trips/cancellations" ){
          setopen(true)
        }else{
          setopen(false)
        }
    }, [pathName])

    const handleClick = () => {
      setopen(!open);
    };
    return (

      <MenuList style={ roles.tripCancellationReasons  || roles.trips ? {} : {display :'none'}} >

          <Tooltip title="Voyages" placement="right">
            <MenuItem onClick={handleClick}>
                <ListItemIcon>
                  <Explore color="primary" />
                </ListItemIcon>
                <ListItemText primary="Voyages" className={listItemColor} />
                {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
            </MenuItem>
          </Tooltip>
          {/* Collapsing items */}
            <Collapse in={open} timeout="auto" unmountOnExit>
                <MenuList component="div" disablePadding>
                    <Tooltip style={ roles.trips ? { } : {display :'none'}}  title="Historique des Voyages" placement="right" >
                        <MenuItem component={Link} to='/trips' selected={pathName === "/trips"}>
                            <ListItemIcon>
                                <CardTravel  />
                            </ListItemIcon>
                            <ListItemText primary="Historique des Voyages"  />
                        </MenuItem>
                    </Tooltip>

                    <Tooltip style={ roles.tripCancellationReasons ? { } : {display : 'none'}}  title="Annulations Voyages" placement="right" >
                        <MenuItem component={Link} to='/trips/cancellations' selected={pathName === "/trips/cancellations"}>
                            <ListItemIcon>
                                <RemoveCircle  />
                            </ListItemIcon>
                            <ListItemText primary="Annulations Voyages" />
                        </MenuItem>
                    </Tooltip>

                </MenuList>

            </Collapse>
        </MenuList>
    )} ;


export const DriverListItems = ({pathName , listItemColor , roles }) => {
    const [open, setopen] = useState(false);

    useEffect(() => {
        if(pathName === "/drivers/info_list" || pathName === "/drivers/subscription" || pathName === "/drivers/baned_list" || pathName === "/drivers/driverFAQsAdmin" || pathName === "/drivers/driverEmployee"  ){
          setopen(true)
        }else{
          setopen(false)
        }
    }, [pathName])

    const handleClick = () => {
      setopen(!open);
    };


    return (
    <MenuList style={ roles.functionalDrivers || roles.subscribedDrivers || roles.blockedDrivers || roles.employeeDriver ? {} : { display :'none'}} >

      <Tooltip title="Gestion des Chauffeurs" placement="right">
        <MenuItem onClick={handleClick}>
            <ListItemIcon>
              <LocalTaxi color="primary" />
            </ListItemIcon>
            <ListItemText primary="Drivers" className={listItemColor} />
            {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
        </MenuItem>
      </Tooltip>
      {/* Collapsing items */}
        <Collapse in={open} timeout="auto" unmountOnExit>
            <MenuList component="div" disablePadding>
                <Tooltip style={ roles.functionalDrivers ? {} : {display :'none'}} title="Chauffeurs Valid" placement="right" >
                    <MenuItem component={Link} to='/drivers/info_list' selected={pathName === "/drivers/info_list"}>
                        <ListItemIcon>
                            <ListAlt  />
                        </ListItemIcon>
                        <ListItemText primary="Chauffeurs Valid"  />
                    </MenuItem>
                </Tooltip>

                <Tooltip style={ roles.subscribedDrivers ? { } : {display :'none'}}  title="Chauffeur non Approuvé" placement="right" >
                    <MenuItem component={Link} to='/drivers/subscription' selected={pathName === "/drivers/subscription"}>
                        <ListItemIcon>
                            <AccountBox  />
                        </ListItemIcon>
                        <ListItemText primary="Chauffeur non Approuvé" />
                    </MenuItem>
                </Tooltip>
      
                <Tooltip style={ roles.blockedDrivers ? { } : {display :'none'}}  title="Chauffeur bannis" placement="right" >
                    <MenuItem component={Link} to='/drivers/baned_list' selected={pathName === "/drivers/baned_list"}>
                    <ListItemIcon>
                      <RemoveCircle  />
                    </ListItemIcon>
                    <ListItemText primary="Chauffeur bannis" />
                  </MenuItem>
                </Tooltip>
      
                <Tooltip  style={ roles.employeeDriver ? { } : {display :'none'}}   title="Driver Employee" placement="right" >
                    <MenuItem component={Link} to='/drivers/driverEmployee' selected={pathName === "/drivers/driverEmployee"}>
                        <ListItemIcon>
                            <Work />
                        </ListItemIcon>
                        <ListItemText primary="Driver Employee" />
                    </MenuItem>
                </Tooltip>

                <Tooltip  style={ roles.driverFAQ ? { } : {display :'none'}}  title="FAQ" placement="right" >
                    <MenuItem component={Link} to='/drivers/driverFAQsAdmin' selected={pathName === "/drivers/driverFAQsAdmin"}>
                        <ListItemIcon>
                            <LiveHelp  />
                        </ListItemIcon>
                        <ListItemText primary="FAQ" />
                    </MenuItem>
                </Tooltip>
            </MenuList>

        </Collapse>
    </MenuList>

)};


export const RiderListItems = ({pathName , listItemColor , roles }) => {
  const [open, setopen] = useState(false);

  useEffect(() => {
      if(pathName === "/riders/info_list" || pathName === "/riders/riderFAQsAdmin" ){
        setopen(true)
      }else{
        setopen(false)
      }
  }, [pathName])

  const handleClick = () => {
    setopen(!open);
  };


  return (
    <MenuList style={ roles.riders || roles.ridersFAQ ? {} : { display :'none'} } >

      <Tooltip title="related riders" placement="right">
        <MenuItem button onClick={handleClick}>
            <ListItemIcon>
              <People color="primary" />
            </ListItemIcon>
            <ListItemText primary="Riders" className={listItemColor} />
            {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
        </MenuItem>
      </Tooltip>

      {/* Collapsing items */}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <MenuList component="div" disablePadding>
            <Tooltip style={ roles.riders ? {} : {display :'none'} } title="Informations" placement="right" >
                <MenuItem  component={Link}   to="/riders/info_list" selected={pathName === "/riders/info_list"}>
                    <ListItemIcon>
                        <ListAlt  />
                    </ListItemIcon>
                    <ListItemText primary="Informations"  />
                </MenuItem>
            </Tooltip>

            <Tooltip style={ roles.ridersFAQ ? {} : {display :'none'} } title="FAQ" placement="right" >
                <MenuItem component={Link}   to="/riders/riderFAQsAdmin" selected={pathName === "/riders/riderFAQsAdmin"}   >
                    <ListItemIcon>
                        <LiveHelp  />
                    </ListItemIcon>
                    <ListItemText primary="FAQ"/>
                </MenuItem>
            </Tooltip>


        </MenuList>
      </Collapse>

    </MenuList>
)};

export const OperationalListItems = ({pathName , listItemColor , roles }) => {
    const [open, setopen] = useState(false);

    useEffect(() => {
        if(pathName === "/operational"  || pathName === "/operational/drivers" || pathName === "/operational/streetRiders" ){
            setopen(true)
        }else{
            setopen(false)
        }
    }, [pathName])

    const handleClick = () => {
        setopen(!open);
    };

    return (
        <MenuList style={ !roles.operationalDrivers || !roles.streetRiders ? {} : {display :'none'} } >
            <Tooltip title="Operational" placement="right">
                <MenuItem onClick={handleClick}>
                    <ListItemIcon>
                        <SettingsApplications color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Operational" className={listItemColor} />
                    {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
                </MenuItem>
            </Tooltip>
            {/* Collapsing items */}
            <Collapse in={open} timeout="auto" unmountOnExit>
                <MenuList component="div" disablePadding>

                    <Tooltip style={ !roles.operationalDriver ? { } : {display :'none'}} title="DriversOperational" placement="right" >
                        <MenuItem component={Link} to='/operational/drivers' selected={pathName === "/operational" || pathName === '/operational/drivers'}>
                            <ListItemIcon>
                                <People  />
                            </ListItemIcon>
                            <ListItemText primary="DriversOperational" />
                        </MenuItem>
                    </Tooltip>
                    <Tooltip   style={ !roles.streetRiders ? {} : {display :'none'} }  title="Street Riders" placement="right" >
                        <MenuItem component={Link} to='/operational/streetRiders' selected={pathName === "/operational/streetRiders"}>
                            <ListItemIcon>
                                <Map  />
                            </ListItemIcon>
                            <ListItemText primary="Street Riders" />
                        </MenuItem>
                    </Tooltip>


                </MenuList>

            </Collapse>
        </MenuList>


    )} ;


export const CommunicationListItems = ({pathName , listItemColor , roles }) => {
    const [open, setopen] = useState(false);

    useEffect(() => {
        if(pathName === "/communication"  || pathName === "/communication/codePromo" || pathName === "/communication/contactUsAnswers" || pathName==="/communication/smsGateway" ){
            setopen(true)
        }else{
            setopen(false)
        }
    }, [pathName])

    const handleClick = () => {
        setopen(!open);
    };

    return (
        <MenuList style={ roles.notificationPush || roles["code promo"] || roles.notificationPush  ? {} : {display :'none'} } >
            <Tooltip title="Communication" placement="right">
                <MenuItem onClick={handleClick}>
                    <ListItemIcon>
                        <Forum color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Communication" className={listItemColor} />
                    {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
                </MenuItem>
            </Tooltip>
            {/* Collapsing items */}
            <Collapse in={open} timeout="auto" unmountOnExit>
                <MenuList component="div" disablePadding>

                    <Tooltip style={ roles.notificationPush ? { } : {display :'none'}} title="Notification Push" placement="right" >
                        <MenuItem component={Link} to='/communication' selected={pathName === "/communication"}>
                            <ListItemIcon>
                                <AddAlert  />
                            </ListItemIcon>
                            <ListItemText primary="Notification Push" />
                        </MenuItem>
                    </Tooltip>
                    <Tooltip   style={ roles["code promo"] ? {} : {display :'none'} }  title="Code Promo" placement="right" >
                        <MenuItem component={Link} to='/communication/codePromo' selected={pathName === "/communication/codePromo"}>
                            <ListItemIcon>
                                <ConfirmationNumber  />
                            </ListItemIcon>
                            <ListItemText primary="Code Promo" />
                        </MenuItem>
                    </Tooltip>

                    <Tooltip style={ roles.contactUs ? {} : {display :'none'} }  title="Contact Us Answers" placement="right" >
                        <MenuItem component={Link} to='/communication/contactUsAnswers' selected={pathName === "/communication/contactUsAnswers"}>
                            <ListItemIcon>
                                <ContactPhone />
                            </ListItemIcon>
                            <ListItemText primary="Contact Us Answers" />
                        </MenuItem>
                    </Tooltip>
                    <Tooltip style={ !roles.smsgateway ? {} : {display :'none'} }  title="SMS Gateway" placement="right" >
                        <MenuItem component={Link} to='/communication/smsGateway' selected={pathName === "/communication/smsGateway"}>
                            <ListItemIcon>
                                <Sms/>
                            </ListItemIcon>
                            <ListItemText primary="SMS Gateway" />
                        </MenuItem>
                    </Tooltip>
                </MenuList>

            </Collapse>
        </MenuList>


    )} ;

/* class ShowCart extends React.Component {
    render() {
        return null;
    }
} */

export const AdditionalPagesListItems = ({history , pathName , listItemColor , roles }) => {
    const [open, setopen] = useState(false);

    useEffect(() => {
        if(pathName === "/additionalPages" || pathName === "/additionalPages/logs" || pathName==='/additionalPages/dashboardUsers' ){
            setopen(true)
        }else{
            setopen(false)
        }
    }, [pathName])

    const handleClick = () => {
        setopen(!open);
    };

    return (
        <MenuList style={ roles.dashboardUsers || roles.logs ? {} : {display :'none'} } >
            <Tooltip title="Additional Pages" placement="right">
                <MenuItem onClick={handleClick}>
                    <ListItemIcon>
                        <AmpStories color="primary" />
                    </ListItemIcon>
                    <ListItemText primary="Additional Pages" className={listItemColor} />
                    {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
                </MenuItem>
            </Tooltip>
            {/* Collapsing items */}
            <Collapse in={open} timeout="auto" unmountOnExit>
                <MenuList component="div" disablePadding>
                    {/*<Tooltip title="Analytics For the dashboard" placement="right" >*/}
                    {/*    <MenuItem component={Link} to='/additionalPages' selected={pathName === "/additionalPages"}>*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <ShowChart  />*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText primary="Analytics For the dashboard" />*/}
                    {/*    </MenuItem>*/}
                    {/*</Tooltip>*/}

                    {/*<Tooltip title="Statistics of the system" placement="right" >*/}
                    {/*    <MenuItem component={Link} to='/additionalPages/statisticsSystem' selected={pathName === "/additionalPages/statisticsSystem"}>*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <PieChart  />*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText primary="Statistics of the system" />*/}
                    {/*    </MenuItem>*/}
                    {/*</Tooltip>*/}
                    {/*<Tooltip title="Statistics of the dashboard" placement="right" >*/}
                    {/*    <MenuItem component={Link} to='/additionalPages/statisticsDashboard' selected={pathName === "/additionalPages/statisticsDashboard"}>*/}
                    {/*        <ListItemIcon>*/}
                    {/*            <Dashboard />*/}
                    {/*        </ListItemIcon>*/}
                    {/*        <ListItemText primary="Statistics of the dashboard" />*/}
                    {/*    </MenuItem>*/}
                    {/*</Tooltip>*/}
                    <Tooltip style={ roles.logs ? {} : {display :'none'} } title="Logs" placement="right" >
                        <MenuItem component={Link} to='/additionalPages/logs' selected={pathName === "/additionalPages/logs"}>
                            <ListItemIcon>
                                <ArtTrack />
                            </ListItemIcon>
                            <ListItemText primary="Logs" />
                        </MenuItem>
                    </Tooltip>
                    <Tooltip style={ roles.dashboardUsers ? {} : {display :'none'} } title="Dashboard Users" placement="right" >
                        <MenuItem component={Link} to='/additionalPages/dashboardUsers' selected={pathName === "/additionalPages/dashboardUsers"}>
                            <ListItemIcon>
                                <SupervisorAccount />
                            </ListItemIcon>
                            <ListItemText primary="Dashboard Users" />
                        </MenuItem>
                    </Tooltip>
                </MenuList>

            </Collapse>
        </MenuList>


    )} ;
